<template> 
 <div class="wz_viewTimerClient">
 {{ time }}
 </div> 
</template>

<script>
import moment from 'moment'
import 'moment-duration-format'
import _ from 'lodash'
export default {
  props: {
    'timeStart': {
      type: Number,
      default: Date.now()
    }
  },

  data () {
    return {
      time: null,
      chrono: null
    }
  },

  methods: {
    startChrono () {
      // date actuelle
      let now = moment(Date.now()).utc()
      // date de reference
      let start = moment(this.timeStart).utc()
      // temps d'attente
      let diff = moment(now).diff(moment(start))
      let duration = moment.duration(diff)
      // temps afficher dans le widget
      this.time = moment(diff).utc().format('H:mm:ss')
      // calcule du seuil afin de faire varier la couleur
      // en fonction du temps d'attente
      // toutes les 2 minutes
      this.$emit('updateSeuil', _.floor(duration.asMinutes() / 2))
    },

    stopChrono () {
      clearInterval(this.chrono)
      this.time = null
    }
  },

  beforeDestroy () {
    this.stopChrono()
  },

  mounted () {
    this.chrono = setInterval(this.startChrono, 1000)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/watcheebox/WzVisiteurTimer.vue